import { NativeModulesProxy, EventEmitter } from '../../../node_modules/expo-modules-core';

// Import the native module. On web, it will be resolved to DerbyfishCapture.web.ts
// and on native platforms to DerbyfishCaptureModule
import DerbyfishCaptureModule from './DerbyfishCaptureModule';
import DerbyfishCaptureView from './DerbyfishCaptureView';

// Native module functions and types

export type StartSessionParams = {
  /** Bitrate in kbps for the livestream */
  bitrateKbps?: number;
  /** Video width in pixels */
  width?: number;
  /** Video height in pixels */
  height?: number;
  /** Waterbody tile identifier for geospatial context */
  waterbodyTile?: string;
};

export type StatusEvent = {
  /** Whether the livestream is currently active */
  live: boolean;
  /** Current bitrate in kbps */
  bitrate?: number;
  /** Current frames per second */
  fps?: number;
};

export type ScanProgressEvent = {
  /** Current scan index (1-based) */
  index: number;
  /** Total number of scans */
  total: number;
};

export type CommitmentsReadyEvent = {
  /** Merkle root of the scan commitments */
  merkleRoot: string;
  /** Grid root hash */
  gridRoot: string;
  /** SPH (Spatial Position Hash) */
  sph: string;
};

export type TimedMetadataPayload = {
  /** Type of marker */
  type: 'HOOK' | 'MEASURE' | 'RELEASE';
  /** Timestamp when marker was created */
  at: number;
};

/**
 * Starts a capture session with the specified parameters
 * @param params Configuration for the capture session
 */
export function startSession(params: StartSessionParams = {}): Promise<void> {
  return DerbyfishCaptureModule.startSession(params);
}

/**
 * Stops the current capture session
 */
export function stopSession(): Promise<void> {
  return DerbyfishCaptureModule.stopSession();
}

/**
 * Sends timed metadata to the livestream
 * @param json JSON string containing the metadata payload
 */
export function sendTimedMetadata(json: string): Promise<void> {
  return DerbyfishCaptureModule.sendTimedMetadata(json);
}

/**
 * Starts a 3x3 grid scan for fish detection
 */
export function start3x3Scan(): Promise<void> {
  return DerbyfishCaptureModule.start3x3Scan();
}

// Define Subscription type
export interface Subscription {
  remove(): void;
}

/**
 * Adds a listener for status updates
 * @param listener Function to call when status changes
 * @returns Subscription that can be used to remove the listener
 */
export function addStatusListener(listener: (event: StatusEvent) => void): Subscription {
  console.warn('EventEmitter not implemented yet, returning fallback subscription');
  return {
    remove: () => {},
  };
}

/**
 * Adds a listener for scan progress updates
 * @param listener Function to call when scan progress changes
 * @returns Subscription that can be used to remove the listener
 */
export function addScanListener(listener: (event: ScanProgressEvent) => void): Subscription {
  console.warn('EventEmitter not implemented yet, returning fallback subscription');
  return {
    remove: () => {},
  };
}

/**
 * Adds a listener for when scan commitments are ready
 * @param listener Function to call when commitments are ready
 * @returns Subscription that can be used to remove the listener
 */
export function addCommitmentsListener(listener: (event: CommitmentsReadyEvent) => void): Subscription {
  console.warn('EventEmitter not implemented yet, returning fallback subscription');
  return {
    remove: () => {},
  };
}

export { DerbyfishCaptureView };
export { default as TestView } from './TestView';
export default DerbyfishCaptureModule;